import { Site } from "@src/@types/SitesTypes";
import { checkIfValidDomain, deepCopy } from "@src/utility/GeneralUtil";
import classnames from "classnames";
import { useEffect, useState } from "react";
import { Plus, Trash2 } from "react-feather";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Label,
  InputGroup,
  InputGroupText,
  Input,
  FormFeedback,
} from "reactstrap";
import axiosInstance from "@src/configs/axiosConfig";
import toast from "react-hot-toast";
import { Account } from "@src/@types/UserAccount";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@src/redux";
import { handleSetOnLoading } from "@src/redux/reducers/userAccount";
import useFetchData from "@src/service/fetchUserAccount";
import { returnErrorOrDefaultMessage } from "@src/utility/responseUtil";
import { notNullString } from "@src/utility/StringUtil";
import useErrorHandle from "@src/utility/hooks/useErrorHandle";

interface ModalSitesProps {
  opened: boolean;
  setOpened: Function;
  typeVision:  "CREATE";
  index: number;
  setSites?: Function;
  site?: Site;
  sites?: Site[];
}

const ModalSitesCreate = ({
  opened,
  setOpened,
  typeVision,
  index,
  setSites,
  site,
  sites,
}: ModalSitesProps) => {
  const dispatch = useDispatch();
  const fetch = useFetchData();
  const handleError = useErrorHandle();
  const account = useSelector<RootState, Account | undefined>(
    (state) => state.userAccount.activeAccount
  );
  const [activeSite, setActiveSite] = useState<Site>(deepCopy(site));

  const siteDefault: Site = {
    domain: "",
    enabled: true,
  };
  const [listAddSites, setListAddSite] = useState<Site[]>([
    deepCopy(siteDefault),
  ]);

  const handleCheckIfValid = (event: any, index: number): boolean => {
    let updateSafe = true;
    let isValid = true;
    setListAddSite((listAddSites) => {
      let localSites = [...listAddSites];
      if (
        localSites[index] &&
        updateSafe &&
        notNullString(localSites[index].domain).length > 4
      ) {
        localSites[index].isValid = checkIfValidDomain(event.target.value);
        isValid = localSites[index].isValid as boolean;
        updateSafe = false;
      }
      return localSites;
    });
    return isValid;
  };

  const handleAddSite = (event: string) => {
    if(listAddSites.length >= 5){
      toast.error("é permitido apenas 5 endereços por transação", {id:"erro-site-some-error"})
      return ;
    }
    let isValid = true;
    listAddSites.forEach(s => { isValid = checkIfValidDomain(s.domain)})
    if (event === "Enter" && isValid)
      setListAddSite([
        ...listAddSites,
        deepCopy(siteDefault),
      ]);
  }

  const handleEditUrlAddSite = (event: any, index: number) => {
    let updateSafe = true;
    setListAddSite((listAddSites) => {
      let localSites = [...listAddSites];
      if (localSites[index] && updateSafe) {
        localSites[index].domain = event.target.value;
        updateSafe = false;
      }
      return localSites;
    });
  };

  const handleRemoveSite = (index: number) => {
    let updateSafe = true;
    setListAddSite((listAddSites) => {
      let localSites = [...listAddSites];
      if (localSites[index] && updateSafe) {
        localSites = localSites.filter((_, i) => i !== index);
        updateSafe = false;
      }
      return localSites;
    });
  };

  const hasSomeErrorBeforeInsert = () => {
    let hasError = false;
    listAddSites.filter(s => s.domain.length > 1).forEach((s) => {
      if (!s.isValid) hasError = true;
    });
    return hasError;
  };

  const handleSite = () => {
    // deve virar um serviço
    if (typeVision === "CREATE") {
      let shouldSave = false;
      let sitesToAdd = listAddSites.filter(s => s.domain.length > 1).map((s) => {
        if (notNullString(s.domain).length > 1) shouldSave = true;
        return s.domain;
      });
      
      if (!shouldSave) {
        toast.error("O site não pode ser vazio.", {id:"erro-site-some-error"});
        return;
      }

      if (sitesToAdd && sitesToAdd.length > 0) {
        if (account?.astvId === undefined) {
          handleError.handleError("error-01", "");
          return;
        }
        if (hasSomeErrorBeforeInsert()) {
          toast.error("Verifique os erros antes de inserir.", {id:"erro-site-some-error"});
          return;
        }
        toast.promise(
          axiosInstance.post("/site/" + account?.astvId, sitesToAdd),
          {
            loading: "Salvando sites",
            success: () => {
              dispatch(handleSetOnLoading(true));
              fetch.fetchUserAccountData();
              setListAddSite([deepCopy(siteDefault)]);
              return "Sites adicionados.";
            },
            error: (err) => {
              setListAddSite([deepCopy(siteDefault)]);
              return returnErrorOrDefaultMessage(err, "Erro ao adicionar Sites")
            },
          }
        );
        setOpened(false);
        return;
      } else {
        toast.error("A lista de Sites não pode ser vazia! ",  {id:"erro-site-lista"});
      }
    } else if (typeVision === "EDIT" && index !== 0 && setSites) {
      let updateSafe = true;
      setSites((sites: Site[]) => {
        let localSites = [...sites];
        if (localSites[index] && updateSafe && activeSite) {
          localSites[index] = activeSite;
          updateSafe = false;
        }
        return localSites;
      });
    } else if (typeVision === "DISABLE" && activeSite) {
      toast.promise(
        axiosInstance.post(`/site/${account?.astvId}/delete`, {
          site: activeSite.domain,
        }),
        {
          loading: "Removendo site",
          success: () => {
            dispatch(handleSetOnLoading(true));
            fetch.fetchUserAccountData();
            return "Site removido.";
          },
          error: (err) =>
            returnErrorOrDefaultMessage(err, "Erro ao Deletar Site"),
        }
      );
      setOpened(false);
    } else {
      toast.error("O site a ser removido não pode ser vazio ", {id:"erro-site"});
    }
  };

  useEffect(() => {
    if (typeVision === "CREATE") {
      let localSite: Site = {
        domain: "",
        enabled: true,
      };
      setActiveSite(localSite);
    } else if ((typeVision === "EDIT" || typeVision === "DISABLE") && site) {
      setActiveSite(deepCopy(site));
    }
  }, [index, typeVision, site]);

  return (
    <Modal
      isOpen={opened}
      toggle={() => setOpened(!opened)}
      className="modal-dialog-centered"
    >
        <>
          {typeVision === "CREATE" ? (
            <>
              <ModalHeader toggle={() => setOpened(!opened)}></ModalHeader>

              <ModalBody className=" text-center">
                <Row className="mb-2">
                  <Col md={12}>
                    <h4>Vamos adicionar novos sites?</h4>
                  </Col>
                  <Col md={12}>
                    <span>
                      Informe o endereço do seu site no campo "Site". Para
                      adicionar mais Sites, pressione Enter ou clique no link
                      "Adicionar outro site"
                    </span>
                  </Col>
                </Row>
                <Row className="justify-content-md-center">
                  <Col md={10}>
                    <div className="mb-1 text-start">
                      <Label className="form-label " for="register-url">
                        Sites
                      </Label>
                    </div>
                  </Col>
                </Row>

                {listAddSites.map((site, index, arr) => (
                  <Row key={index} className="justify-content-md-center">
                    <Col md={10}>
                      <div className="mb-1 text-start">
                        <InputGroup
                          className={classnames({
                            "input-group-merge": arr.length > 2,
                            "is-invalid":
                              site?.isValid !== undefined && !site?.isValid,
                          })}
                        >
                          <Input
                            type="text"
                            id="register-url"
                            placeholder={"sites.com"}
                            autoFocus
                            required
                            invalid={
                              site?.isValid !== undefined && !site?.isValid
                            }
                            value={site?.domain || ""}
                            onChange={(event) =>
                              handleEditUrlAddSite(event, index)
                            }
                            onBlur={(event) => handleCheckIfValid(event, index)}
                            onKeyDown={(event) => {
                              handleCheckIfValid(event, index);
                              if (event.key === "Enter") handleAddSite("Enter");
                            }}
                          />
                          <InputGroupText
                            hidden={arr.length < 2}
                            title="Excluir endereço"
                            tabIndex={0}  
                            className="clickable"
                            onClick={() => handleRemoveSite(index)}
                          >
                            <Trash2
                              aria-label="Excluir endereço"
                              size={14}
                            />
                          </InputGroupText>
                          <FormFeedback>
                            Endereço informado inválido! Utilize o formato
                            semelhante aos exemplos:
                            <strong> https://assistive.com.br </strong> e{" "}
                            <strong> http://assistive.com.br </strong>.
                          </FormFeedback>
                        </InputGroup>
                      </div>
                    </Col>
                  </Row>
                ))}
                <Row className="justify-content-md-center">
                  <Col md={11} className="text-start">
                    <Button
                      hidden={listAddSites.length >=5}
                      color="link"
                      onClick={() =>
                        handleAddSite("Enter")
                      }
                    >
                      <Plus size={16}></Plus> Adicionar outro site
                    </Button>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <Button block color="primary" onClick={() => handleSite()}>
                  Salvar novos sites
                </Button>{" "}
              </ModalFooter>
            </>
          ) : typeVision === "EDIT" ? (
            <>
              <ModalHeader toggle={() => setOpened(!opened)}></ModalHeader>

              <ModalBody className=" text-center">
                <Row className="mb-2">
                  <Col md={12}>
                    <h4>Editar sites</h4>
                  </Col>
                </Row>
                <Row className="justify-content-md-center mb-2">
                  <Col md={8}>
                    <span>
                      Informe o endereço do seu site no campo "Site". Para
                      editar clique em salvar edição
                    </span>
                  </Col>
                </Row>
                <Row className="justify-content-md-center">
                  <Col md={10}>
                    <div className="mb-1 text-start">
                      <Label className="form-label " for="register-username">
                        Sites
                      </Label>
                      <InputGroup
                        className={classnames({
                          "input-group-merge": true,
                        })}
                      >
                        <Input
                          type="text"
                          id="register-username"
                          placeholder={"sites.com"}
                          autoFocus
                          value={activeSite?.domain}
                          onChange={(event) =>
                            setActiveSite({
                              ...activeSite,
                              domain: event.target.value,
                            })
                          }
                        />
                        <InputGroupText>
                          <Trash2
                            size={14}
                            onClick={() =>
                              setActiveSite({ ...activeSite, domain: "" })
                            }
                          />
                        </InputGroupText>
                      </InputGroup>
                    </div>
                  </Col>
                </Row>
                <Row className="justify-content-md-center">
                  <Col md={10}>
                    <Input
                      type="text"
                      id="register-username"
                      placeholder={"seudominio.com"}
                      autoFocus
                      value={activeSite?.domain}
                      onChange={(event) =>
                        setActiveSite({
                          ...activeSite,
                          domain: event.target.value,
                        })
                      }
                    />
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <Button block color="primary" onClick={() => handleSite()}>
                  Salvar edição
                </Button>{" "}
              </ModalFooter>
            </>
          ) : typeVision === "DISABLE" ? (
            <>
              <ModalHeader toggle={() => setOpened(!opened)}></ModalHeader>

              <ModalBody className=" text-center">
                <Row className="mb-2">
                  <Col md={12}>
                    <h4>
                      Você realmente deseja remover o domínio{" "}
                      <a href="threads.com" target="_blank">
                        {activeSite?.domain || ""}
                      </a>
                      ?
                    </h4>
                  </Col>
                </Row>
                <Row className="justify-content-md-center mb-2">
                  <Col md={8}>
                    <span>
                      Ao inativar um site cadastrado o widget presente em seu
                      site será desativado. Você pode ativa-lo novamente a
                      qualquer momento.
                    </span>
                  </Col>
                </Row>
                <Row className="justify-content-md-center mb-3">
                  <Col md={10}>
                    <Button
                      block
                      color="primary"
                      onClick={() => handleSite()} //medina
                    >
                      Quero inativar o site
                    </Button>{" "}
                  </Col>
                </Row>
              </ModalBody>
            </>
          ) : (
            <></>
          )}
        </>
    </Modal>
  );
};
export default ModalSitesCreate;
